<div class="data-card">
  <span class="data-card-icon" [inlineSVG]="svg"></span>
  <h2 class="data-card-stats">{{ statistic }}</h2>
  <div class="data-card-text">
    <p>{{ description }}</p>
  </div>
  <span *ngIf="!last" class="data-card-divider"></span>
</div>
